module.exports = __webpack_public_path__ + "img/tap.c662c4c4.png";